import React, { useState, useEffect } from "react";
import "./IgnosiSolutionsPage.css";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";

import heroImg from "../images/bgimageBusiness.png";

function IgnosiSolutionsPage() {

  /* ================= FORM STATE ================= */

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [widgetId, setWidgetId] = useState(null);
  const { getResponse } = useRecaptcha();

  useEffect(() => {
    if (window.grecaptcha) {
      const container = document.getElementById("recaptcha-ignosi-solutions");
      if (container && container.innerHTML === "") {
        try {
          const id = window.grecaptcha.render(container, {
            // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
             sitekey: window.RECAPTCHA_SITE_KEY,
          });
          setWidgetId(id);
        } catch (err) {
          console.error("reCAPTCHA IgnosiSolutionsPage render error:", err);
        }
      }
    }
  }, []);

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    email: "",
    organization: "",
    challenges: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.full_name || !formData.phone) {
      setMessage("❌ Name & Phone required");
      return;
    }

    setLoading(true);

    try {
      const token = getResponse(widgetId);
      if (!token) {
        setMessage("❌ Please complete the reCAPTCHA");
        setLoading(false);
        return;
      }
      const fd = new FormData();
      Object.keys(formData).forEach(k => fd.append(k, formData[k]));
      fd.append("_type", "ignosi_demo");
      fd.append("tk", token);

      const res = await fetch(
        BASE_URL + "/DemoApi/saveData",
        {
          method: "POST",
          body: fd
        }
      );

      const result = await res.json();

      if (result.status) {
        setMessage("✅ Demo Request Submitted");

        setFormData({
          full_name: "",
          phone: "",
          email: "",
          organization: "",
          challenges: ""
        });
      } else {
        setMessage("❌ " + (result.message || "Verification Failed"));
      }

    } catch (err) {
      console.error("Submission Error:", err);
      setMessage("❌ Submission Failed. Check Console.");
    }

    setLoading(false);
  };


  /* ================= LENDING ================= */

  const lendingSolutions = [
    {
      title: "Gold Loan Solution",
      features: [
        "Dynamic Scheme Configuration",
        "AI-Powered Fake Gold Detection",
        "Digital KYC & Biometric Authentication",
        "Flexible Repayment Options",
        "Ornament Management",
        "Renewal Options",
        "NPA Automation",
        "Auction Management",
        "Daily Gold Index Report",
        "Audit & Compliance"
      ]
    },
    {
      title: "Personal Loan Solution",
      features: [
        "Dynamic Product Factory",
        "Instant KYC Verification",
        "Smart EMI Calculator",
        "Agent Management",
        "Mobile Field Collection",
        "Automated Recovery",
        "Arbitration Module"
      ]
    },
    {
      title: "Business Loan Solution",
      features: [
        "Business KYC Verification",
        "Cash Flow-Based Lending",
        "Loan Demand Forecasting",
        "Collateral Management",
        "Financial Monitoring",
        "MSME Scheme Integration"
      ]
    },
    {
      title: "Education Loan Solution",
      features: [
        "Institution Verification",
        "Co-borrower Management",
        "Moratorium Handling",
        "Disbursement Scheduling",
        "Post Placement Tracking"
      ]
    },
    {
      title: "Microfinance Loan Solution",
      features: [
        "JLG Management",
        "Center Collection System",
        "Small Ticket Automation",
        "Social Impact Tracking",
        "NBFC Compliance"
      ]
    },
    {
      title: "Vehicle Loan Solution",
      features: [
        "RC & Insurance Tracking",
        "Hypothecation Management",
        "Vehicle Valuation",
        "Repossession Management",
        "Auction Integration"
      ]
    }
  ];


  /* ================= INVESTMENT ================= */

  const investmentSolutions = [
    {
      title: "Savings Deposit",
      features: [
        "Multi Account Support",
        "Interest Calculation",
        "Nomination Management",
        "Transaction Limits",
        "Digital Passbook"
      ]
    },
    {
      title: "Recurring Deposit",
      features: [
        "Flexible Tenure",
        "Auto Debit Setup",
        "Premature Closure",
        "Loan Against RD",
        "Renewal Automation"
      ]
    },
    {
      title: "Fixed Deposit",
      features: [
        "Multiple Scheme Types",
        "Interest Payout Options",
        "TDS Management",
        "Renewal Instructions",
        "Digital FD Certificate"
      ]
    },
    {
      title: "Loan from Customers",
      features: [
        "Deposit Linked Lending",
        "Cross Sell Automation",
        "Security Creation",
        "Interest Netting"
      ]
    },
    {
      title: "Debentures & Subordinate Debts",
      features: [
        "Instrument Management",
        "Investor Registry",
        "Coupon Payment",
        "Redemption Management",
        "Regulatory Compliance"
      ]
    }
  ];


  /* ================= UI ================= */

  return (
    <>

      {/* ================= HERO ================= */}

      <section
        className="ignosi-hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >

        <div className="ignosi-wrapper">

          <div className="ignosi-left">
            <h1>IGNOSI Solutions</h1>
            <h3>Comprehensive Lending & Deposit Management Platform</h3>

            <p>
              Unified ecosystem covering lending,
              investments, automation,
              analytics and regulatory compliance.
            </p>
          </div>


          {/* ===== FORM ===== */}

          <div className="ignosi-right">

            <form
              className="demo-form-ignosi"
              onSubmit={handleSubmit}
            >

              <input
                name="full_name"
                placeholder="Full Name*"
                value={formData.full_name}
                onChange={handleChange}
              />

              <input
                name="phone"
                placeholder="Phone Number*"
                value={formData.phone}
                onChange={handleChange}
              />

              <input
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
              />

              <input
                name="organization"
                placeholder="Organization Name"
                value={formData.organization}
                onChange={handleChange}
              />

              {/* ✅ CHALLENGES FIELD */}
              <textarea
                name="challenges"
                placeholder="What challenges are you looking to solve?"
                value={formData.challenges}
                onChange={handleChange}
              />

              <div
                id="recaptcha-ignosi-solutions"
                style={{ marginBottom: "15px" }}
              ></div>

              <button type="submit" disabled={loading}>
                {loading ? "Submitting..." : "Book Demo"}
              </button>

              {message && <p>{message}</p>}

            </form>

          </div>

        </div>
      </section>


      {/* ================= LENDING ================= */}

      <section className="solution-section">
        <h2>Lending Solutions</h2>

        <div className="solution-grid">
          {lendingSolutions.map((item, i) => (
            <div className="solution-card" key={i}>
              <h3>{item.title}</h3>
              <ul>
                {item.features.map((f, idx) =>
                  <li key={idx}>{f}</li>
                )}
              </ul>
            </div>
          ))}
        </div>
      </section>


      {/* ================= INVESTMENT ================= */}

      <section className="solution-section alt">
        <h2>Investment Solutions</h2>

        <div className="solution-grid">
          {investmentSolutions.map((item, i) => (
            <div className="solution-card" key={i}>
              <h3>{item.title}</h3>
              <ul>
                {item.features.map((f, idx) =>
                  <li key={idx}>{f}</li>
                )}
              </ul>
            </div>
          ))}
        </div>
      </section>


      {/* ================= WHY IGNOSI ================= */}

      <section className="why-ignosi-final">

        <h2>Why Choose IGNOSI Solutions?</h2>

        <div className="why-grid">
          <div>✅ End-to-End Coverage</div>
          <div>✅ AI-Powered Intelligence</div>
          <div>✅ Regulatory Ready</div>
          <div>✅ Scalable Architecture</div>
          <div>✅ Omnichannel Experience</div>
        </div>

      </section>

    </>
  );
}

export default IgnosiSolutionsPage;